import { render, staticRenderFns } from "./ReloadRouterLink.vue?vue&type=template&id=fe27defc&lang=pug"
import script from "./ReloadRouterLink.vue?vue&type=script&lang=js"
export * from "./ReloadRouterLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports